export const pdfPickerPtBR = {
  title: "Escolha as páginas do PDF",
  description: "Este PDF tem {count} páginas. Selecione até {max} para enviar à IA.",
  ranges: "Páginas e intervalos",
  placeholder: "Ex.: 1-8, 12, 20-25",
  selected: "{count} de {max} páginas selecionadas",
  page: "Página {page}",
  window: "Páginas {from}–{to} de {total}",
  previous: "Páginas anteriores",
  next: "Próximas páginas",
  clear: "Limpar seleção",
  cancel: "Cancelar",
  confirm: "Usar {count} páginas",
  loading: "Carregando prévias…",
  previewError: "Não foi possível exibir a prévia. Você ainda pode selecionar pelo número da página.",
  order: "Use a posição das páginas no arquivo. O recorte mantém a ordem, renumera a partir de 1 e remove links interativos.",
  preparing: "Preparando PDF…",
  errors: {
    empty_selection: "Selecione pelo menos uma página.",
    invalid_selection: "Use números e intervalos separados por vírgulas, como 1-8, 12.",
    page_out_of_bounds: "Há uma página que não existe neste PDF.",
    too_many_pages: "Selecione no máximo 60 páginas.",
    encrypted_pdf: "O PDF está protegido. Envie uma cópia sem senha.",
    unsupported_annotations: "Este PDF tem anotações visuais nas páginas selecionadas. Exporte uma cópia com as anotações incorporadas às páginas e envie novamente.",
    invalid_pdf: "Não foi possível ler este PDF. Tente exportá-lo novamente.",
  },
};

export const pdfPickerEnUS = {
  title: "Choose PDF pages",
  description: "This PDF has {count} pages. Select up to {max} to send to the AI.",
  ranges: "Pages and ranges",
  placeholder: "E.g. 1-8, 12, 20-25",
  selected: "{count} of {max} pages selected",
  page: "Page {page}",
  window: "Pages {from}–{to} of {total}",
  previous: "Previous pages",
  next: "Next pages",
  clear: "Clear selection",
  cancel: "Cancel",
  confirm: "Use {count} pages",
  loading: "Loading previews…",
  previewError: "The preview could not be displayed. You can still select by page number.",
  order: "Use page positions in the file. The extract keeps their order, renumbers from 1, and removes interactive links.",
  preparing: "Preparing PDF…",
  errors: {
    empty_selection: "Select at least one page.",
    invalid_selection: "Use comma-separated numbers and ranges, such as 1-8, 12.",
    page_out_of_bounds: "A selected page does not exist in this PDF.",
    too_many_pages: "Select no more than 60 pages.",
    encrypted_pdf: "The PDF is protected. Send a copy without a password.",
    unsupported_annotations: "The selected pages contain visual annotations. Export a copy with annotations flattened into the pages and send it again.",
    invalid_pdf: "This PDF could not be read. Try exporting it again.",
  },
};

export const pdfPickerEsES = {
  title: "Elige las páginas del PDF",
  description: "Este PDF tiene {count} páginas. Selecciona hasta {max} para enviar a la IA.",
  ranges: "Páginas e intervalos",
  placeholder: "Ej.: 1-8, 12, 20-25",
  selected: "{count} de {max} páginas seleccionadas",
  page: "Página {page}",
  window: "Páginas {from}–{to} de {total}",
  previous: "Páginas anteriores",
  next: "Páginas siguientes",
  clear: "Borrar selección",
  cancel: "Cancelar",
  confirm: "Usar {count} páginas",
  loading: "Cargando vistas previas…",
  previewError: "No se pudo mostrar la vista previa. Todavía puedes seleccionar por número de página.",
  order: "Usa la posición de las páginas en el archivo. El recorte conserva el orden, renumera desde 1 y elimina enlaces interactivos.",
  preparing: "Preparando PDF…",
  errors: {
    empty_selection: "Selecciona al menos una página.",
    invalid_selection: "Usa números e intervalos separados por comas, como 1-8, 12.",
    page_out_of_bounds: "Una página seleccionada no existe en este PDF.",
    too_many_pages: "Selecciona como máximo 60 páginas.",
    encrypted_pdf: "El PDF está protegido. Envía una copia sin contraseña.",
    unsupported_annotations: "Las páginas seleccionadas contienen anotaciones visuales. Exporta una copia con las anotaciones incorporadas a las páginas y envíala de nuevo.",
    invalid_pdf: "No se pudo leer este PDF. Intenta exportarlo de nuevo.",
  },
};
